const categorias = [ 
  { text: "1era", value: "1era" },
  { text: "2da", value: "2da" },
  { text: "3era", value: "3ra" },
  { text: "4ta", value: "4ta" },
  { text: "5ta", value: "5ta" },
  { text: "6ta", value: "6ta" },
  { text: "7ma", value: "7ma" },
  { text: "8va", value: "8va" },
  { text: "9na", value: "9na" },
  { text: "Libres", value: "Libres" },    
  { text: "Principiantes", value: "Principiantes" },  
]

const categoriasSuma = [
  { text: "SUMA 3", value: "SUMA 3" },
  { text: "SUMA 4", value: "SUMA 4" },
  { text: "SUMA 5", value: "SUMA 5" },
  { text: "SUMA 6", value: "SUMA 6" },
  { text: "SUMA 7", value: "SUMA 7" },
  { text: "SUMA 8", value: "SUMA 8" },
  { text: "SUMA 9", value: "SUMA 9" },
  { text: "SUMA 10", value: "SUMA 10" },
  { text: "SUMA 11", value: "SUMA 11" },
  { text: "SUMA 12", value: "SUMA 12" },
  { text: "SUMA 13", value: "SUMA 13" },
  { text: "SUMA 14", value: "SUMA 14" },
  { text: "SUMA 15", value: "SUMA 15" },
  { text: "SUMA 16", value: "SUMA 16" },
  { text: "SUMA 17", value: "SUMA 17" },
]

const deportes = [
  { text: "Padel", value: "Padel"},
  { text: "Tenis", value: "Tenis"},
  { text: "Futbol", value: "Futbol"}
]

interface CategoriasConfig {
  categorias?: { text: string; value: string }[];
  categoriasSuma?: { text: string; value: string }[];
}

interface DeportesConfig {
  deportes?: { text: string; value: string }[];
}

const categoriasPorInstitucion: Record<number, CategoriasConfig> = {
  0: {
    categorias: [
      { text: "A", value: "A" },
      { text: "B", value: "B" },
    ],
    categoriasSuma: [
      { text: "SUMA PRO", value: "SUMA PRO" },
      { text: "SUMA ELITE", value: "SUMA ELITE" },
    ],
  },
};

const deportesPorInstitucion: Record<number, DeportesConfig> = {
  0: {
    deportes: [
      { text: "A", value: "A" },
      { text: "B", value: "B" },
    ],
  },
};

export function getCategoriasConfig(idInstitucion?: number) {
  const custom = idInstitucion
    ? categoriasPorInstitucion[idInstitucion]
    : undefined;

  return {
    categorias: custom?.categorias ?? categorias,
    categoriasSuma: custom?.categoriasSuma ?? categoriasSuma,
  };
}

export function getDeportesConfig(idInstitucion?: number) {
  const custom = idInstitucion
    ? deportesPorInstitucion[idInstitucion]
    : undefined

  return {
    deportes: custom?.deportes ?? deportes
  }
}